module.exports = __webpack_public_path__ + "assets/img/NPC017.6dc15d2a.png";